// classes for Leyden styles, just to keep them in one place
// eslint-disable-next-line import/prefer-default-export
export const LEYDEN_TAB_GROUP_CLASSES = {
  tabGroup: 'c-els-tab-group',
  tabGroupDivider: 'c-els-tab-group__divider',
  tabGroupItem: 'c-els-tab-group__item',
  tabGroupItemActive: 'c-els-tab-group__item--active',
  tabGroupItemDisabled: 'c-els-tab-group__item--disabled',
  tabGroupText: 'c-els-tab-group__text',
};
